import { useFlags } from "launchdarkly-react-client-sdk";

import { NewRerverseEltSyncPage } from "./NewReverseEltSync";
import CreateSyncPage from "./new/CreateSyncPage";

export default function NewSyncPage() {
  const { newReverseEtlSetupExperience } = useFlags();
  if (newReverseEtlSetupExperience) {
    return <CreateSyncPage />;
  }
  return <NewRerverseEltSyncPage />;
}
